import Payment from '@piconetworks/module-payment'
import createDuck from '../baseDuck'

export default Payment({
    createDuck,
})
